<template>
  <header id="page-topbar">
      <div class="navbar-brand-box">
        <router-link to="/" class="logo">
          <img src="@/assets/images/knot.svg" alt height="40" />
        </router-link>
      </div>
  </header>
</template>
<style>

</style>

<script>
export default {
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
